import { French } from 'flatpickr/dist/l10n/fr.js';

/**
 * Returns the Flatpickr locale used for an application locale.
 *
 * @param locale Active application locale.
 * @returns French date-picker text for French locales; otherwise the Flatpickr default.
 */
export function flatpickrLocaleFor(locale: string) {
  return locale.toLowerCase().startsWith('fr') ? French : undefined;
}
